/*用户信息 企业信息*/

const state = {
  //用户信息
  userInfo: {},
  //用户企业信息
  userCompany: {},
  //路由菜单配置
  routerMenuList: {},
  //导航菜单配置
  userMenuList: [],
  //铃铛消息
  userNews: {},
  //角色类型
  roleType: '',
  //当前账号权限列表
  permissionMap: {},
  //当前用户权限
  pmsIds: 'false',
  //字典数据
  pageDict: {},
  //UseInfo 是否完成
  userInfoInitFlag: false,
  //企业插件
  pluginList: [],
  //用户公司列表
  companyList:[],
  //外呼实例ID
  callCustomerPO:'',
}

const getters = {
  userInfo: state => {
    return state.userInfo
  },
  userCompany: state => {
    return state.userCompany
  },
  routerMenuList: state => {
    return state.routerMenuList
  },
  userMenuList: state => {
    return state.userMenuList
  },
  userNews: state => {
    return state.userNews
  },
  roleType: state => {
    return state.roleType
  },
  permissionMap: state => {
    return state.permissionMap
  },
  pmsIds: state => {
    return state.pmsIds
  },
  pageDict: state => {
    return state.pageDict
  },
  userInfoInitFlag: state => {
    return state.userInfoInitFlag
  },
  getYxlevel: () => {
    let map = new Map()
    state.pageDict.commonMap.yxLevel.map(item => {
      map.set('key' + item.dicCode, item.dicName)
    })
    return map
  },
  pluginMap: state => {
    let map = new Map()
    state.pluginList.map(item => {
      map.set(item.pmsId,item)
    })

    return map
  },
  companyList:state=>{
    return state.companyList
  },
  callCustomerPO:state=>{
    return state.callCustomerPO
  }
}

const mutations = {
  setUserInfo(state, data) {
    state.userInfo = data
  },
  setUserCompany(state, data) {
    document.title = '草莓卷-' + data.companyName
    state.userCompany = data
    state.userMenuList = data.menuList
    data.menuList.map((item) => {
      state.routerMenuList[item.type] = item.selectFlag
    })
  },
  setUserNews(state, data) {
    state.userNews = data
  },
  setRoleType(state, data) {
    state.roleType = data
  },
  setPermissionMap(state, data) {
    state.permissionMap = data
  },
  setPmsId(state, data) {
    state.pmsIds = data
  },
  setUserPageDict(state, data) {
    let bgColor = ''
    let styleNode = document.createElement('style')
    for (let item in data.statusMap) {
      bgColor += '.service' + item + ' td{background-color:' + data.statusMap[item].backColor + ' !important;color:' + data.statusMap[item].fontColor + ' !important}'
    }
    bgColor += '.serviceTrackRed td {background-color:#F56C6C !important;color:#fff !important;}'
    styleNode.innerHTML = bgColor
    document.getElementsByTagName('body')[0].appendChild(styleNode)
    state.pageDict = data
  },
  setUserInfoInitFlag(state, data) {
    state.userInfoInitFlag = data
  },
  setPluginList(state, data) {
    state.pluginList = data
  },
  setCompanyList(state,data){
    state.companyList = data
  },
  setcallCustomerPO(state,data){
    state.callCustomerPO = data
  }
}

const actions = {
//获取所有用户信息
  getUserBaseInfo(context, data) {
    let that = data
    that.$http.get('login/base_info',).then((data) => {
      if (data) {
        if (data.code === 100000) {
          context.commit('setcallCustomerPO',data.data.callCustomerPO)
          context.commit('setUserInfo', data.data.staffDetail)
          context.commit('setPluginList', data.data.pluginList)
          context.commit('setUserCompany', data.data.company)
          context.commit('setUserNews', data.data.news)
          context.commit('setUserPageDict', data.data.pageDict)
          context.commit('setPermissionMap', data.data.permissionMap)
          context.commit('setCompanyList',data.data.companyList)
          let msgSet = data.data.staffDetail.msgSet
          localStorage.removeItem('msgSet')
          localStorage.setItem('msgSet', JSON.stringify(msgSet))
          if (!state.userInfoInitFlag) {
            context.commit('setUserInfoInitFlag', true)
            that.$root.$emit('get_baseInfo_finish')
          }
        } else {
          that.$Message.error(data.msg)
        }
      }
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/model/useInfor.js